export const OPTANON_CATEGORY_2 = 'optanonCategory2';
export const OPTANON_CATEGORY_3 = 'optanonCategory3';
export const OPTANON_CATEGORY_4 = 'optanonCategory4';

export const OptanonCategories = {
  [OPTANON_CATEGORY_2]: 'optanon-category-C0002',
  [OPTANON_CATEGORY_3]: 'optanon-category-C0003',
  [OPTANON_CATEGORY_4]: 'optanon-category-C0004',
};
